query GetSearchEmployees(
  $page: Int
  $limit: Int
  $stringFilters: [EmployeeStringFilterInput!]
  $booleanFilters: [EmployeeBooleanFilterInput!]
  $sortBy: String
) {
  searchEmployees(
    page: $page
    limit: $limit
    stringFilters: $stringFilters
    booleanFilters: $booleanFilters
    sortBy: $sortBy
  ) {
    collection {
      id
      name
      salesforceId
      title
      welcomeCallLink
      profileName
      email
      worksAtFp
      salesforceLicenceActive
      signInStatus
      team {
        id
        name
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
